import React from 'react';
import { logError } from '@utils/usefulFuncs';
import { FlatButton, TransparentFlatButton } from './FlatButton';
import styled from 'styled-components';
import { Body7, Container } from '@ui';

const CopyButtonWrapper = styled.div`
  button {
    /* The transparent variant has no border to sit inside, so horizontal padding would only
       indent its label away from whatever it's labeling. */
    padding: ${({ $transparent }) => ($transparent ? '4px 0' : '4px 16px')};
  }
`;

// `transparent` drops the button to the secondary tier for callers where copying isn't the
// primary action on the panel. Opt-in so existing call sites keep the solid CTA.
export const CopyButton = ({ text, transparent = false }) => {
  const [isShowingCopied, setIsShowingCopied] = React.useState(false);

  const onCopyClick = () => {
    try {
      const textBlob = new Blob([text], { type: 'text/plain' });
      navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': textBlob,
        }),
      ]);
    } catch (e) {
      logError('failed clipboard, attempting fallback', e);
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
    setIsShowingCopied(true);
  };

  React.useEffect(() => {
    if (isShowingCopied) {
      setTimeout(() => {
        setIsShowingCopied(false);
      }, 2600);
    }
  }, [isShowingCopied]);

  if (isShowingCopied) {
    // Same box either way so the label doesn't shift when it swaps in — left-aligned for the
    // transparent variant to match its flush button label.
    return transparent ? (
      <Container height={26} verticallyCenter>
        <Body7 bold>Copied to clipboard...</Body7>
      </Container>
    ) : (
      <Container height={26} horizontal={9} centerAll>
        <Body7 bold>Copied to clipboard...</Body7>
      </Container>
    );
  }

  const Button = transparent ? TransparentFlatButton : FlatButton;

  return (
    <CopyButtonWrapper $transparent={transparent}>
      <Button onClick={onCopyClick}>Copy Text</Button>
    </CopyButtonWrapper>
  );
};
